import { UserType } from '@/types';

// Known react-admin resource names used by useCanAccess({ resource, action }).
// The matcher below is dynamic (any `resource:action` string in the user's
// permissions grants access), so this list only documents the resources the
// app currently gates. Extend when wiring a new permissioned resource.
export const KNOWN_PERMISSION_RESOURCES = [
    'quote',
    'project',
    'contractor_owner',
    'user',
    'role',
    'project_file_config',
    'ticket',
    'lead',
    'help_document',
    'receipt',
    'permit',
    'municipalities',
    'permit-files',
] as const;

// FIXME: This should be exported from the ra-core package
type CanAccessParams<
    RecordType extends Record<string, any> = Record<string, any>,
> = {
    action: string;
    resource: string;
    record?: RecordType;
};

export const canAccess = <
    RecordType extends Record<string, any> = Record<string, any>,
>(
    params: CanAccessParams<RecordType>
) => {
    const userItem = localStorage.getItem(import.meta.env.VITE_USER_STORAGE_KEY);
    const localUser = userItem ? (JSON.parse(userItem) as UserType) : null;
    if (!localUser) return false;

    if(localUser.administrator)
        return true;
    
    let canAccess = false;
    // Card charges have no permissions of their own; the API guards them with receipt:*.
    const base = params.resource === 'expense_transactions' ? 'receipts' : params.resource;
    let resource = base;
    let resource2 = base;
    let action = params.action;

    if (action === 'list' || action === 'show') {
        action = 'read';
    } else if (action === 'edit') {
        action = 'update';
    }

    if(resource2.endsWith('s')) {
        resource2 = resource2.slice(0, -1);
    }

    const local_permission = `${resource}:${action}`;
    const local_permission2 = `${resource2}:${action}`;

    localUser.permissions.forEach((permission) => {
        if(canAccess) return;

        if(local_permission === permission || local_permission2 === permission) {
            canAccess = true;
        }
    });

    return canAccess;
};
